// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] + "." + {"315":"e6ad87f0","923":"0807e091"}[chunkId] + ".chunk.js";
};